import cn from 'classnames';
import { __ } from '../../../translations';
import styles from '../styles/player.module.sass';

/**
 * Creates and attaches a tooltip to all elements matching the given identifier.
 * The tooltip displays the provided text and toggles its visibility on mouseover and mouseout events.
 *
 * @param identifier - A CSS selector string used to identify the player buttons.
 * @param text - The text content to display inside the tooltip.
 */
function createTooltip(identifier: string, text: string) {
    const elements = document.querySelectorAll(identifier);
    if (!elements.length) return;

    elements.forEach((el) => {
        const tooltipSpan = document.createElement('span');
        tooltipSpan.className = cn(styles.tooltip, styles.hidden);
        tooltipSpan.innerText = text;

        function toggleRewindTooltip() {
            tooltipSpan.classList.toggle(styles.hidden);
        }

        el.addEventListener('mouseover', toggleRewindTooltip);
        el.addEventListener('mouseout', toggleRewindTooltip);

        const existingTooltip = el.querySelector(`.${styles.tooltip}`);

        if (existingTooltip) {
            existingTooltip.remove();
        }

        el.appendChild(tooltipSpan);
    });
}

/**
 * Loads tooltips for various player UI elements by attaching localized labels to them.
 *
 * @throws Will log an error if tooltip creation fails for any element.
 */
export const useLoadTooltips = () => {
    createTooltip('.ui-rewindbutton', __('player_lables_fast_rewind'));
    createTooltip('.ui-forwardbutton', __('player_lables_fast_forward'));
    createTooltip('.bmpui-ui-fullscreentogglebutton', __('player_lables_Fullscreen'));
    createTooltip('.bmpui-ui-playbacktogglebutton', `${__('player_lables_Pause')}/${__('player_lables_Play')}`);
    createTooltip('.bmpui-ui-volumetogglebutton', `${__('player_lables_Mute')}/${__('player_lables_Unmute')}`);
    createTooltip('.ui-startover-btn', __('player_labels_start_over'));
};
